var DataStorage = function(storageVarName, storageType) {
	this.autoSaveName = storageVarName || null;
	this.storageType = storageType == 'sessionStorage' ? 'sessionStorage' : 'localStorage';
	this.data = {};
	this.load();
};
DataStorage.prototype = {
	'set': function(data, value) {
		if (value !== undefined) {
			var key = data;
			var data = {};
			data[key] = value;
		}
		for (var key in data) {
			this.data[key] = data[key];
			this[key] = (function(value) {
				return function(){
					return value;
				};
			})(data[key]);
		}
		this.save();
	},
	'get': function(param) {
		if (param) {
			return this.data[param];
		} else {
			return this.data;
		}
	},
	'save': function() {
		if (this.autoSaveName !== null && window[this.storageType]) {
			window[this.storageType].setItem(this.autoSaveName, JSON.stringify(this.data));
		}
	},
	'load': function() {
		if (this.autoSaveName !== null && window[this.storageType]) {
			var data = window[this.storageType].getItem(this.autoSaveName);
			if (data) {
				this.set(JSON.parse(data));
			}
		}
	},
	'clearAll': function() {
		this.data = {};
		if (this.autoSaveName !== null) {
			this.save(this.autoSaveName);
		}
	}
};
